"use client";

import { useState } from "react";
import "./landing.css";
import { Nav, Hero } from "./Hero";
import {
  Problem,
  Transformation,
  SystemSection,
  FakiSection,
  RolesSection,
  Pricing,
  FinalCTA,
  Footer,
} from "./Sections";
import { ContactModal, type ContactSubject } from "./ContactModal";
import { useOrkestriaTheme, type OrkestriaTheme } from "@/lib/theme";

function toLandingTheme(t: OrkestriaTheme): "blueDark" | "night" | "light" {
  if (t === "dark") return "blueDark";
  if (t === "night") return "night";
  return "light";
}
function fromLandingTheme(t: "blueDark" | "night" | "light"): OrkestriaTheme {
  if (t === "blueDark") return "dark";
  if (t === "night") return "night";
  return "light";
}

export default function LandingV2() {
  const { theme, setTheme } = useOrkestriaTheme();
  const landingTheme = toLandingTheme(theme);

  const [contact, setContact] = useState<{
    open: boolean;
    subject: ContactSubject;
  }>({ open: false, subject: "demo" });

  const openContact = (subject: ContactSubject) =>
    setContact({ open: true, subject });
  const closeContact = () => setContact((c) => ({ ...c, open: false }));

  const glow = 0.55;
  const density = 2;
  const autoOrbit = true;
  const style = "realistic" as const;
  const palette = "mono" as const;

  return (
    <div className="ork-landing">
      <Nav
        theme={landingTheme}
        onTheme={(v: "blueDark" | "night" | "light") =>
          setTheme(fromLandingTheme(v))
        }
        onContact={openContact}
      />
      <Hero
        glow={glow}
        density={density}
        autoOrbit={autoOrbit}
        palette={palette}
        style={style}
        theme={landingTheme}
        onContact={openContact}
      />
      <Problem />
      <Transformation />
      <SystemSection />
      <RolesSection />
      <FakiSection />
      <Pricing onContact={openContact} />
      <FinalCTA onContact={openContact} />
      <Footer />

      <ContactModal
        open={contact.open}
        subject={contact.subject}
        onClose={closeContact}
      />
    </div>
  );
}
